export default __webpack_public_path__ + "static/2-62613f62d79e9bc7dc5ae113b3c16777.jpeg";